import { ClientScheduleType } from "utils/transformApiSchedule";

export default function particularDaySampleDates(
  schedule: Pick<ClientScheduleType, "firstPayment">,
): Date[] {
  const { firstPayment } = schedule;
  if (firstPayment) return [firstPayment];

  return [new Date()];
}
